import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import DefaultTable, { Line } from "../../ui-library/CustomTable/DefaultTable";
import moment from "moment";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { DateFormat } from "../../../modules/constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 60px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const StudyStatusHistory = (props) => {
  const {
    onClose,
    getData,
    searchedParams,
    totalitems,
    theme,
    history,
    studyStatuses,
  } = props;

  const defaultProps = {
    headers: [
      { label: "Date", key: "date" },
      { label: "Status", key: "status" },
      { label: "Changed by", key: "changed_by" },
      { label: "Reason for Change", key: "change_reason" },
    ],
    hasSearch: 0,
    haspagesizefilter: 1,
    haspagination: 1,
    smallTable: true,
    searchedParams,
    getData,
  };

  return (
    <Container data-testid="study-status-history">
      <DefaultTable
        {...defaultProps}
        maincolor={theme?.gray}
        totalitems={totalitems}
      >
        {history?.map((history, index) => (
          <Line key={`${history.Key}_${index}`}>
            <span>
              {moment
                .utc(history.ValidFrom)
                .utcOffset(history.TimeZoneOffset)
                .format(DateFormat.BASE_FORMAT)}
            </span>
            <span>
              {studyStatuses &&
                studyStatuses[
                  Object.keys(studyStatuses).find(
                    (statusKey) =>
                      studyStatuses[statusKey].id === history.Status
                  )
                ]?.value}
            </span>
            <span>{history.CreatedBy}</span>
            <span>{history.ReasonForChange}</span>
          </Line>
        ))}
      </DefaultTable>
      {onClose && (
        <ActionButtonsContainer>
          <PrimaryButton onClick={onClose}>Close</PrimaryButton>
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

StudyStatusHistory.defaultProps = {
  onClose: null,
};

StudyStatusHistory.propTypes = {
  onClose: PropTypes.func,
  searchedParams: PropTypes.object.isRequired,
  getData: PropTypes.func.isRequired,
  totalitems: PropTypes.number.isRequired,
  history: PropTypes.array.isRequired,
  studyStatuses: PropTypes.object.isRequired,
};

export default withTheme(StudyStatusHistory);
